import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import "../../../../assets/css/admin/adminlogin/adminlogin.css";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import logo from "../../../../assets/images/logo.png"; // apna logo path
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { EyeIcon, EyeOffIcon } from "lucide-react";

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { baseUrl, setLoggedInAdmin, regTpChecker } = useContext(AppContext);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [resettingPassword, setResettingPassword] = useState(false);
  const checkAdminEmail = (e) => {
    e.preventDefault();

    if (!email) {
      alert("Please enter your email");
      return;
    }

    setCheckingEmail(true);

    axios
      .post(`${baseUrl}/admin/auth/checkAdminEmail`, {
        email: email,
      })
      .then((response) => {
        setCheckingEmail(false);

        if (response.data.success) {
          setEmailVerified(true);
        }
      })
      .catch((error) => {
        setCheckingEmail(false);
        setEmailVerified(false);

        alert(error.response?.data?.message || "Email not found");
      });
  };
  const resetAdminPassword = (e) => {
    e.preventDefault();
    const passwordError = regTpChecker("password", password);

    if (!newPassword || !confirmPassword) {
      alert("Please enter both passwords");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    setResettingPassword(true);

    axios
      .post(`${baseUrl}/admin/auth/resetAdminPassword`, {
        email: email,
        new_password: newPassword,
        confirm_password: confirmPassword,
      })
      .then((response) => {
        setResettingPassword(false);

        if (response.data.success) {
          alert("Password reset successfully");

          setForgotPassword(false);
          setEmailVerified(false);
          setNewPassword("");
          setConfirmPassword("");
          setEmail("");
        }
      })
      .catch((error) => {
        setResettingPassword(false);

        alert(error.response?.data?.message || "Something went wrong");
      });
  };

  const loginAdmin = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/admin/auth/adminlogin`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("ADMIN LOGIN RESPONSE:", response.data);

        if (response.data.success === true) {
          localStorage.setItem("adminToken", response.data.token);

          localStorage.setItem(
            "loggedInAdmin",
            JSON.stringify(response.data.admin),
          );

          setLoggedInAdmin(response.data.admin);

          navigate("/admin-dashboard");
        } else {
          console.log("Backend message:", response.data.message);
        }
      })
      .catch((err) => {
        console.log("========== ADMIN LOGIN ERROR ==========");
        console.log("Status:", err.response?.status);
        console.log("Data:", err.response?.data);
        console.log("Message:", err.response?.data?.message);
        console.log("Error:", err.message);
        console.log("========================================");
      });
  };

  // Auto-login ab token se ho, credentials se nahi
  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem("adminToken");
    const storedAdmin = localStorage.getItem("loggedInAdmin");

    if (token && storedAdmin) {
      setLoggedInAdmin(JSON.parse(storedAdmin));
      setLoading(false);
      // Optional: token validity check karne ke liye ek "verifyToken" API call kar sakti hain
    } else {
      setLoading(false);
    }
  }, []);
  return (
    <div className="login-wrapper">
      {loading ? (
        <Spinner />
      ) : (
        <Container>
          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={7}>
              <div className="login-card">
                {/* LOGO */}
                <div className="sidebar-logo text-center mb-4">
                  <img src={logo} alt="Logo" className="logo-icon" />
                </div>

                <h3 className="text-center mb-4">Admin Login</h3>

                <Form>
                  {/* EMAIL */}
                  <Form.Group className="mb-3">
                    <Form.Label>Admin Email</Form.Label>

                    <Form.Control
                      type="email"
                      placeholder="admin@time4pulse.pk"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>
                  {/* Error Message */}
                  {errorMessage && (
                    <div className="buyer-error-message">{errorMessage}</div>
                  )}
                  {/* Success Message */}
                  {successMessage && (
                    <div className="buyer-success-message">
                      {successMessage}
                    </div>
                  )}

                  {/* ================= LOGIN MODE ================= */}
                  {!forgotPassword && (
                    <>
                      {/* PASSWORD */}
                      <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>

                        <div className="input-wrapper">
                          <FaLock className="input-icon" />

                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />

                          <button
                            type="button"
                            className="toggle-password"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                      </Form.Group>

                      {/* FORGOT PASSWORD */}
                      <div className="text-end mb-3">
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => {
                            setForgotPassword(true);
                            setEmailVerified(false);
                          }}
                        >
                          Forgot Password?
                        </button>
                      </div>

                      {/* LOGIN BUTTON */}
                      <Button
                        type="button"
                        className="login-btn w-100"
                        onClick={loginAdmin}
                      >
                        Login to Admin
                      </Button>
                    </>
                  )}

                  {/* ================= FORGOT PASSWORD ================= */}
                  {forgotPassword && (
                    <>
                      {/* EMAIL CHECK */}
                      {!emailVerified && (
                        <>
                          <Button
                            type="button"
                            className="login-btn w-100 mt-3"
                            onClick={checkAdminEmail}
                            disabled={checkingEmail}
                          >
                            {checkingEmail ? "Checking..." : "Continue"}
                          </Button>
                        </>
                      )}

                      {/* ================= PASSWORD RESET ================= */}
                      {emailVerified && (
                        <>
                          {/* NEW PASSWORD */}
                          <Form.Group className="mb-3 mt-3">
                            <Form.Label>New Password</Form.Label>

                            <div className="input-wrapper">
                              <FaLock className="input-icon" />
                              <input
                                type={showNewPassword ? "text" : "password"}
                                className="sl-input"
                                placeholder="Enter new password"
                                value={newPassword}
                                onChange={(e) => {
                                  setNewPassword(e.target.value);
                                  setErrorMessage(
                                    regTpChecker("password", e.target.value),
                                  );
                                }}
                              />
                              <button
                                type="button"
                                className="sl-eye-btn"
                                onClick={() => setShowNewPassword((p) => !p)}
                                aria-label={
                                  showNewPassword
                                    ? "Hide new password"
                                    : "Show new password"
                                }
                              >
                                {showNewPassword ? <EyeOffIcon /> : <EyeIcon />}
                              </button>{" "}
                            </div>
                          </Form.Group>

                          {/* CONFIRM PASSWORD */}
                          <Form.Group className="mb-3">
                            <Form.Label>Confirm Password</Form.Label>

                            <div className="input-wrapper">
                              <FaLock className="input-icon" />

                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="sl-input"
                                placeholder="Confirm new password"
                                value={confirmPassword}
                                onChange={(e) =>
                                  setConfirmPassword(e.target.value)
                                }
                              />

                              <button
                                type="button"
                                className="sl-eye-btn"
                                onClick={() =>
                                  setShowConfirmPassword((p) => !p)
                                }
                                aria-label={
                                  showConfirmPassword
                                    ? "Hide confirm password"
                                    : "Show confirm password"
                                }
                              >
                                {showConfirmPassword ? (
                                  <EyeOffIcon />
                                ) : (
                                  <EyeIcon />
                                )}
                              </button>
                            </div>
                          </Form.Group>

                          {/* RESET BUTTON */}
                          <Button
                            type="button"
                            className="login-btn w-100"
                            onClick={resetAdminPassword}
                            disabled={resettingPassword}
                          >
                            {resettingPassword
                              ? "Resetting..."
                              : "Reset Password"}
                          </Button>
                        </>
                      )}

                      {/* BACK TO LOGIN */}
                      <div className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-link"
                          onClick={() => {
                            setForgotPassword(false);
                            setEmailVerified(false);
                            setNewPassword("");
                            setConfirmPassword("");
                          }}
                        >
                          ← Back to Login
                        </button>
                      </div>
                    </>
                  )}

                  {/* BOTTOM LINK */}
                  <p className="text-center mt-3 small">
                    Not an admin? <a href="/">Back to site</a>
                  </p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

export default AdminLogin;
